export const STATUS_TITULAIRE = 0
export const STATUS_SUPPLEANT = 1

export const STATUSES = [
    {key: STATUS_TITULAIRE, label: 'Titulaire'},
    {key: STATUS_SUPPLEANT, label: 'Suppléant'}
]
